module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [_c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(0), _vm._v(" "), (_vm.resetPasswordPanel) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.mod_message))]), _vm._v(" "), _c('label', [_vm._v("Enter Current password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.current_password),
      expression: "admin.current_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.admin.current_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.current_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Enter New password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.new_password),
      expression: "admin.new_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.admin.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.new_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loading) ? _c('span', [_vm._v("..processing...")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-password', '')
      }
    }
  }, [_vm._v("Click to Reset")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(1), _vm._v(" "), (_vm.resetEmailPanel) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.mod_message))]), _vm._v(" "), _c('label', [_vm._v("Enter Current Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.current_email),
      expression: "admin.current_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.admin.current_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.current_email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Enter New Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.new_email),
      expression: "admin.new_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.admin.new_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.new_email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loading) ? _c('span', [_vm._v("..processing...")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.resetEmail
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-email', '')
      }
    }
  }, [_vm._v("Click to Reset")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(2), _vm._v(" "), _c('center', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "href": "cnpro_categories"
    }
  }, [_vm._v("Manage CNpro Categories")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('center', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "href": "business_categories"
    }
  }, [_vm._v("Manage Business Categories")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(3), _vm._v(" "), (_vm.editPlans) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.plan_name),
      expression: "plan.plan_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plan.plan_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan.plan_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.plan_amount),
      expression: "plan.plan_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.plan.plan_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan.plan_amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editPlansAndPricing
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, _vm._l((_vm.plans), function(plan) {
    return _c('div', [_c('p', [_vm._v(_vm._s(plan.plan_name) + " - ₦" + _vm._s(plan.plan_amount) + "\r\n                                "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-plan', plan)
        }
      }
    }, [_vm._v("Edit")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(4), _vm._v(" "), (_vm.editServiceCharge) ? _c('div', [_c('label', [_vm._v("Edit Service Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_charge.service_charge),
      expression: "service_charge.service_charge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.service_charge.service_charge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service_charge.service_charge = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editServiceCharges
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, _vm._l((_vm.service_charges), function(service_charge) {
    return _c('div', [_c('p', [_vm._v("Service Charge = " + _vm._s(service_charge.service_charge) + "%\r\n                                "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-service-charge', service_charge)
        }
      }
    }, [_vm._v("Edit")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(5), _vm._v(" "), (_vm.editCnpayCharge) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(6), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v(_vm._s(_vm.cnpay_charge.cnpay_chg_range1_min))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpay_charge.cnpay_chg_range1_max),
      expression: "cnpay_charge.cnpay_chg_range1_max"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cnpay_charge.cnpay_chg_range1_max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpay_charge.cnpay_chg_range1_max = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpay_charge.cnpay_chg_range1_pay),
      expression: "cnpay_charge.cnpay_chg_range1_pay"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cnpay_charge.cnpay_chg_range1_pay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpay_charge.cnpay_chg_range1_pay = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v(_vm._s(_vm.var1))])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpay_charge.cnpay_chg_range2_max),
      expression: "cnpay_charge.cnpay_chg_range2_max"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cnpay_charge.cnpay_chg_range2_max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpay_charge.cnpay_chg_range2_max = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpay_charge.cnpay_chg_range2_pay),
      expression: "cnpay_charge.cnpay_chg_range2_pay"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cnpay_charge.cnpay_chg_range2_pay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpay_charge.cnpay_chg_range2_pay = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v(_vm._s(_vm.var2))])]), _vm._v(" "), _c('td', [_c('label', [_vm._v(_vm._s(_vm.cnpay_charge.cnpay_chg_range3_max))])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpay_charge.cnpay_chg_range3_pay),
      expression: "cnpay_charge.cnpay_chg_range3_pay"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cnpay_charge.cnpay_chg_range3_pay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpay_charge.cnpay_chg_range3_pay = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editCnpayCharges
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, _vm._l((_vm.cnpay_charges), function(cnpay_charge) {
    return _c('div', [(cnpay_charge.cnpay_chg_id == 1) ? _c('h4', {
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, [_vm._v("CNpay - Remita Charges")]) : _vm._e(), _vm._v(" "), (cnpay_charge.cnpay_chg_id == 2) ? _c('h4', {
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, [_vm._v("Wallet Processing Fees")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("1. ₦" + _vm._s(cnpay_charge.cnpay_chg_range1_min) + " - ₦" + _vm._s(cnpay_charge.cnpay_chg_range1_max) + " - ₦" + _vm._s(cnpay_charge.cnpay_chg_range1_pay))]), _vm._v(" "), _c('p', [_vm._v("2. ₦" + _vm._s(cnpay_charge.cnpay_chg_range2_min) + " - ₦" + _vm._s(cnpay_charge.cnpay_chg_range2_max) + " - ₦" + _vm._s(cnpay_charge.cnpay_chg_range2_pay))]), _vm._v(" "), _c('p', [_vm._v("3. ₦" + _vm._s(cnpay_charge.cnpay_chg_range3_min) + " - "), (cnpay_charge.cnpay_chg_id == 2) ? _c('span', [_vm._v("₦" + _vm._s(_vm.max_wallet_topup_amount))]) : _c('span', [_vm._v("₦" + _vm._s(cnpay_charge.cnpay_chg_range3_max))]), _vm._v(" - ₦" + _vm._s(cnpay_charge.cnpay_chg_range3_pay))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-cnpay-charge', cnpay_charge)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('br'), _c('br')])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(7), _vm._v(" "), (_vm.editCnpayComm) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('label', [_vm._v("Edit " + _vm._s(_vm.cnpay_commission.cnpay_partner) + " - " + _vm._s(_vm.cnpay_commission.cnpay_comm) + "%")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpay_commission.cnpay_comm),
      expression: "cnpay_commission.cnpay_comm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cnpay_commission.cnpay_comm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpay_commission.cnpay_comm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editCnpayCommissions
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, _vm._l((_vm.cnpay_commissions), function(cnpay_commission) {
    return _c('div', [_c('p', [_vm._v(_vm._s(cnpay_commission.cnpay_partner) + " - " + _vm._s(cnpay_commission.cnpay_comm) + "%\r\n                                    "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-cnpay-comm', cnpay_commission)
        }
      }
    }, [_vm._v("Edit")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(8), _vm._v(" "), (_vm.editDefaultCharge) ? _c('div', [_c('label', [_vm._v("Edit Charge")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.default_charge.charge_name) + "\r\n                                "), _c('p', {
    staticStyle: {
      "font-size": "11px",
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.default_charge.charge_notes))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_amount),
      expression: "default_charge.charge_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_amount = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.default_charge.charge_has_ranges == 1) ? _c('div', {
    staticStyle: {
      "padding": "1em",
      "border": "#f3d3d3 1px dashed"
    }
  }, [_c('p', [_vm._v("\r\n                                    Range 1: "), _c('b', [_vm._v(_vm._s(_vm.default_charge.charge_min_range1))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(_vm.default_charge.charge_max_range1))]), _c('br'), _vm._v("\r\n                                    From:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_min_range1),
      expression: "default_charge.charge_min_range1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_min_range1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_min_range1 = $event.target.value
      }
    }
  }), _c('br'), _vm._v("\r\n                                    To:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_max_range1),
      expression: "default_charge.charge_max_range1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_max_range1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_max_range1 = $event.target.value
      }
    }
  }), _c('br'), _vm._v("\r\n                                    Amount:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_amt_range1),
      expression: "default_charge.charge_amt_range1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_amt_range1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_amt_range1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\r\n                                    Range 2: "), _c('b', [_vm._v(_vm._s(_vm.default_charge.charge_min_range2))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(_vm.default_charge.charge_max_range2))]), _c('br'), _vm._v("\r\n                                    From:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_min_range2),
      expression: "default_charge.charge_min_range2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_min_range2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_min_range2 = $event.target.value
      }
    }
  }), _c('br'), _vm._v("\r\n                                    To:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_max_range2),
      expression: "default_charge.charge_max_range2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_max_range2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_max_range2 = $event.target.value
      }
    }
  }), _c('br'), _vm._v("\r\n                                    Amount:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_amt_range2),
      expression: "default_charge.charge_amt_range2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_amt_range2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_amt_range2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\r\n                                    Range: "), _c('b', [_vm._v(_vm._s(_vm.default_charge.charge_min_range3))]), _vm._v(" - "), _c('b', [_vm._v("above")]), _c('br'), _vm._v("\r\n                                    From:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_min_range3),
      expression: "default_charge.charge_min_range3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_min_range3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_min_range3 = $event.target.value
      }
    }
  }), _c('br'), _vm._v("\r\n                                    To:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_max_range3),
      expression: "default_charge.charge_max_range3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_max_range3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_max_range3 = $event.target.value
      }
    }
  }), _c('br'), _vm._v("\r\n                                    Amount:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_amt_range3),
      expression: "default_charge.charge_amt_range3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_amt_range3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_amt_range3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editDefaultCharges
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, _vm._l((_vm.default_charges), function(default_charge) {
    return _c('div', [_c('p', [_vm._v(_vm._s(default_charge.charge_name) + " = " + _vm._s(default_charge.charge_amount) + "(" + _vm._s(default_charge.charge_unit) + ")\r\n                                "), (default_charge.charge_id != 1) ? _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-default-charge', default_charge)
        }
      }
    }, [_vm._v("Edit")]) : _vm._e()]), _vm._v(" "), (default_charge.charge_has_ranges == 1) ? _c('div', {
      staticStyle: {
        "padding": "1em",
        "border": "#f3d3d3 1px dashed"
      }
    }, [_c('h6', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(default_charge.charge_name) + " Charge Range")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(default_charge.charge_min_range1))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(default_charge.charge_max_range1))]), _vm._v(" - " + _vm._s(default_charge.charge_amt_range1) + "(" + _vm._s(default_charge.charge_unit) + ")")]), _vm._v(" "), (default_charge.charge_min_range2 > 0) ? _c('p', [_c('b', [_vm._v(_vm._s(default_charge.charge_min_range2))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(default_charge.charge_max_range2))]), _vm._v(" - " + _vm._s(default_charge.charge_amt_range2) + "(" + _vm._s(default_charge.charge_unit) + ")")]) : _vm._e(), _vm._v(" "), (default_charge.charge_min_range3 > 0) ? _c('p', [_c('b', [_vm._v(_vm._s(default_charge.charge_min_range3))]), _vm._v(" - "), _c('b', [_vm._v("above")]), _vm._v(" - " + _vm._s(default_charge.charge_amt_range3) + "(" + _vm._s(default_charge.charge_unit) + ")")]) : _vm._e()]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(9), _vm._v(" "), (_vm.editServiceReward) ? _c('div', {
    staticClass: "stats-body"
  }, [(_vm.service_reward_error != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.service_reward_error))]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Service: " + _vm._s(_vm.service_reward.service_reward_service))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward_type),
      expression: "service_reward_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "P",
      "value": "P"
    },
    domProps: {
      "checked": _vm._q(_vm.service_reward_type, "P")
    },
    on: {
      "__c": function($event) {
        _vm.service_reward_type = "P"
      }
    }
  }), _vm._v("Percentage | \r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward_type),
      expression: "service_reward_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "C",
      "value": "C"
    },
    domProps: {
      "checked": _vm._q(_vm.service_reward_type, "C")
    },
    on: {
      "__c": function($event) {
        _vm.service_reward_type = "C"
      }
    }
  }), _vm._v("Cash\r\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward.service_reward_reward),
      expression: "service_reward.service_reward_reward"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.service_reward.service_reward_reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service_reward.service_reward_reward = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward_activation_status),
      expression: "service_reward_activation_status"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.service_reward_activation_status, "1")
    },
    on: {
      "__c": function($event) {
        _vm.service_reward_activation_status = "1"
      }
    }
  }), _vm._v("Active | \r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward_activation_status),
      expression: "service_reward_activation_status"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.service_reward_activation_status, "0")
    },
    on: {
      "__c": function($event) {
        _vm.service_reward_activation_status = "0"
      }
    }
  }), _vm._v("Not-Active\r\n                                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editServiceRewards
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : _c('div', {
    staticClass: "stats-body"
  }, [(_vm.addServiceReward) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('h4', [_vm._v("Add Reward to a Service")]), _c('br'), _vm._v(" "), (_vm.service_reward_error != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.service_reward_error))]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Service:\r\n                                                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward.service),
      expression: "service_reward.service"
    }],
    staticClass: "form_control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.service_reward.service = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.cnservices), function(s) {
    return _c('option', {
      domProps: {
        "value": s.service_id
      }
    }, [_vm._v(_vm._s(s.service_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward_type),
      expression: "service_reward_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "P",
      "value": "P"
    },
    domProps: {
      "checked": _vm._q(_vm.service_reward_type, "P")
    },
    on: {
      "__c": function($event) {
        _vm.service_reward_type = "P"
      }
    }
  }), _vm._v("Percentage | \r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward_type),
      expression: "service_reward_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "C",
      "value": "C"
    },
    domProps: {
      "checked": _vm._q(_vm.service_reward_type, "C")
    },
    on: {
      "__c": function($event) {
        _vm.service_reward_type = "C"
      }
    }
  }), _vm._v("Cash\r\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward.reward),
      expression: "service_reward.reward"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.service_reward.reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service_reward.reward = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addServiceRewards
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : _c('div', {
    staticClass: "stats-body",
    staticStyle: {
      "margin-bottom": "2em",
      "border-bottom": "#aaacad solid 1px",
      "font-size": "13px"
    }
  }, [_vm._m(10), _vm._v(" "), _c('table', _vm._l((_vm.services_rewards), function(sr) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "60%",
        "padding": "3px"
      }
    }, [_vm._v(_vm._s(sr.service_reward_service))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%",
        "padding": "3px"
      }
    }, [(sr.service_reward_type == 'C') ? _c('span', [_vm._v("₦")]) : _vm._e(), _vm._v(_vm._s(sr.service_reward_reward)), (sr.service_reward_type == 'P') ? _c('span', [_vm._v("%")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%",
        "padding": "3px",
        "font-size": "12px"
      }
    }, [(sr.service_reward_activation_status == 1) ? _c('span', [_vm._v("Active")]) : _c('span', [_vm._v("Not-Active")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%",
        "padding": "3px"
      }
    }, [_c('button', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "type": "button",
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-service-reward', sr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "padding": "3px"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button",
        "title": "Delete?"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('delete-service-reward', sr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-service-reward', '')
      }
    }
  }, [_vm._v("Add New Reward")]), _vm._v(" "), _c('br'), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 stats-info widget",
    staticStyle: {
      "height": "auto",
      "background": "#eef9f0"
    }
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(11), _vm._v(" "), (_vm.component_view.editPagaServiceGroup || _vm.editPagaServiceGroup) ? _c('div', {
    staticClass: "stats-body"
  }, [(_vm.paga_service_error != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.paga_service_error))]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Group: " + _vm._s(_vm.paga_service_group.paga_service_group_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Group Name:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group.paga_service_group_name),
      expression: "paga_service_group.paga_service_group_name"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.paga_service_group.paga_service_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group.paga_service_group_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Title:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group.paga_service_group_title),
      expression: "paga_service_group.paga_service_group_title"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pay your Electricty Bills...."
    },
    domProps: {
      "value": (_vm.paga_service_group.paga_service_group_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group.paga_service_group_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editPagaServiceGroups
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '');
        _vm.setComponentView('');
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : (_vm.component_view.editPagaServiceGroupMerchant || _vm.editPagaServiceGroupMerchant) ? _c('div', {
    staticClass: "stats-body"
  }, [(_vm.paga_service_error != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.paga_service_error))]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Edit Merchant:\r\n                                            "), (_vm.paga_service_group_merchant.paga_service_group_merchant_service_group_type == 'MOBILEOPS') ? _c('span', [_vm._v("\r\n                                                    " + _vm._s(_vm.paga_service_group_merchant.paga_service_group_mobile_operatorName))]) : _vm._e(), _vm._v(" "), (_vm.paga_service_group_merchant.paga_service_group_merchant_service_group_type == 'MERCHANT') ? _c('span', [_vm._v("\r\n                                                    " + _vm._s(_vm.paga_service_group_merchant.paga_service_group_merchant_displayName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Commision Type:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commission_type),
      expression: "commission_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "P",
      "value": "P"
    },
    domProps: {
      "checked": _vm._q(_vm.commission_type, "P")
    },
    on: {
      "__c": function($event) {
        _vm.commission_type = "P"
      }
    }
  }), _vm._v("Percentage | \r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commission_type),
      expression: "commission_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "C",
      "value": "C"
    },
    domProps: {
      "checked": _vm._q(_vm.commission_type, "C")
    },
    on: {
      "__c": function($event) {
        _vm.commission_type = "C"
      }
    }
  }), _vm._v("Cash\r\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Commision:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group_merchant.paga_service_group_merchant_commission),
      expression: "paga_service_group_merchant.paga_service_group_merchant_commission"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.paga_service_group_merchant.paga_service_group_merchant_commission)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group_merchant.paga_service_group_merchant_commission = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_reward_type),
      expression: "paga_service_reward_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "P",
      "value": "P"
    },
    domProps: {
      "checked": _vm._q(_vm.paga_service_reward_type, "P")
    },
    on: {
      "__c": function($event) {
        _vm.paga_service_reward_type = "P"
      }
    }
  }), _vm._v("Percentage | \r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_reward_type),
      expression: "paga_service_reward_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "C",
      "value": "C"
    },
    domProps: {
      "checked": _vm._q(_vm.paga_service_reward_type, "C")
    },
    on: {
      "__c": function($event) {
        _vm.paga_service_reward_type = "C"
      }
    }
  }), _vm._v("Cash\r\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group_merchant.paga_service_group_merchant_reward),
      expression: "paga_service_group_merchant.paga_service_group_merchant_reward"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.paga_service_group_merchant.paga_service_group_merchant_reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group_merchant.paga_service_group_merchant_reward = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_reward_activation_status),
      expression: "paga_service_reward_activation_status"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.paga_service_reward_activation_status, "1")
    },
    on: {
      "__c": function($event) {
        _vm.paga_service_reward_activation_status = "1"
      }
    }
  }), _vm._v("Active | \r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_reward_activation_status),
      expression: "paga_service_reward_activation_status"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.paga_service_reward_activation_status, "0")
    },
    on: {
      "__c": function($event) {
        _vm.paga_service_reward_activation_status = "0"
      }
    }
  }), _vm._v("Not-Active\r\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Maximum Purchase Amount:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group_merchant.paga_service_group_merchant_max_purchase_amount),
      expression: "paga_service_group_merchant.paga_service_group_merchant_max_purchase_amount"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "number",
      "id": "0",
      "value": "0"
    },
    domProps: {
      "value": (_vm.paga_service_group_merchant.paga_service_group_merchant_max_purchase_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group_merchant.paga_service_group_merchant_max_purchase_amount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Merchant - Do not display services")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "13px"
    }
  }, [_vm._v("Please copy and paste the exact service you would not want to be displayed")]), _vm._v(" "), ((Object.keys(_vm.paga_service_group_merchant.paga_service_group_merchant_services_do_not_display).length > 0)) ? _c('div', _vm._l((_vm.paga_service_group_merchant.paga_service_group_merchant_services_do_not_display), function(dnd_service, dndex) {
    return _c('li', {
      staticStyle: {
        "display": "inline-block",
        "list-style": "none"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deletePagaMerchantDoNotDisplayServices(dnd_service)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "border-radius": "50%",
        "background-color": "#cc0000",
        "padding": "0px 5px",
        "color": "#ffffff"
      }
    }, [_vm._v("x")]), _vm._v("\r\n                                                    " + _vm._s(dnd_service.service_name) + "\r\n                                                ")])])
  })) : _c('p', {
    staticStyle: {
      "color": "#05630a"
    }
  }, [_vm._v("No service listed")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_merchant_dnds.service_name),
      expression: "paga_merchant_dnds.service_name"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "text",
      "id": "0",
      "value": "0"
    },
    domProps: {
      "value": (_vm.paga_merchant_dnds.service_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_merchant_dnds.service_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addPagaMerchantDoNotDisplayServices(_vm.paga_service_group_merchant.paga_service_group_merchant_id)
      }
    }
  }, [_vm._v("Add")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Merchant Image")]), _vm._v(" "), (_vm.paga_service_group_merchant.paga_service_group_merchant_attached_image != '') ? _c('span', [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "height": "8.5em"
    },
    attrs: {
      "src": _vm.img_url + _vm.paga_service_group_merchant.paga_service_group_merchant_attached_image
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Change Image\r\n                                            "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.paga_service_group_merchant.paga_service_group_merchant_id)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editPagaServiceGroupMerchants
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '');
        _vm.setComponentView('');
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : (_vm.component_view.addPagaServiceGroup || _vm.addPagaServiceGroup) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('h4', [_vm._v("Add New PAGA Service Group")]), _c('br'), _vm._v(" "), (_vm.service_reward_error != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.paga_service_error))]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Group Name:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group.group_name),
      expression: "paga_service_group.group_name"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.paga_service_group.group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group.group_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Title:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group.group_title),
      expression: "paga_service_group.group_title"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pay your Electricty Bills...."
    },
    domProps: {
      "value": (_vm.paga_service_group.group_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group.group_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addPagaServiceGroups
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '');
        _vm.setComponentView('');
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : _c('div', {
    staticClass: "stats-body",
    staticStyle: {
      "margin-bottom": "2em",
      "border-bottom": "#aaacad solid 1px",
      "font-size": "13px"
    }
  }, [_vm._l((_vm.paga_service_groups), function(service_group) {
    return _c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "margin-bottom": "1em",
        "border-bottom": "#aaacad solid 1px",
        "font-size": "13px"
      }
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h6', [_c('u', [_vm._v(_vm._s(service_group.paga_service_group_name))])]), _vm._v(" "), _c('P', [_vm._v(_vm._s(service_group.paga_service_group_title))]), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "type": "button",
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-paga-service-group', service_group);
          _vm.setComponentView('editPagaServiceGroup')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), (_vm.deletePagaServiceGroup && (service_group.paga_service_group_id == _vm.paga_service_group.paga_service_group_id)) ? _c('div', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you really want to delete?\r\n                                            "), _c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button",
        "title": "Delete?"
      },
      on: {
        "click": function($event) {
          _vm.deletePagaServiceGroups()
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-xs",
      attrs: {
        "type": "button",
        "title": "Delete?"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-action', '')
        }
      }
    }, [_vm._v("No")])]) : _c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button",
        "title": "Delete?"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('delete-paga-service-group', service_group);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-9"
    }, [(_vm.addPagaServiceGroupMerchant && (service_group.paga_service_group_id == _vm.paga_service_group.paga_service_group_id)) ? _c('div', {
      staticClass: "stats-body"
    }, [_c('h4', [_vm._v("Add New Merchant")]), _c('br'), _vm._v(" "), (_vm.paga_service_error != '') ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.paga_service_error))]) : _vm._e(), _vm._v(" "), _c('form', [(service_group.paga_service_group_for == 'MERCHANT') ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Merchant:\r\n                                                        "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_group_merchant.merchant),
        expression: "paga_service_group_merchant.merchant"
      }],
      staticClass: "form_control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.paga_service_group_merchant.merchant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.paga_merchants), function(s, index) {
      return _c('option', {
        domProps: {
          "value": s.paga_merchant_id
        }
      }, [_vm._v(_vm._s(s.paga_merchant_displayName))])
    })], 2)])]) : _vm._e(), _vm._v(" "), (service_group.paga_service_group_for == 'MOBILEOPS') ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Mobile Operator:\r\n                                                        "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_group_merchant.merchant),
        expression: "paga_service_group_merchant.merchant"
      }],
      staticClass: "form_control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.paga_service_group_merchant.merchant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.paga_mobile_operators), function(s, index) {
      return _c('option', {
        domProps: {
          "value": s.paga_mobile_operator_id
        }
      }, [_vm._v(_vm._s(s.paga_mobile_operator_name))])
    })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('b', [_vm._v("Commision Type:")]), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.commission_type),
        expression: "commission_type"
      }],
      staticClass: "form_control",
      attrs: {
        "type": "radio",
        "id": "P",
        "value": "P"
      },
      domProps: {
        "checked": _vm._q(_vm.commission_type, "P")
      },
      on: {
        "__c": function($event) {
          _vm.commission_type = "P"
        }
      }
    }), _vm._v("Percentage | \r\n                                                    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.commission_type),
        expression: "commission_type"
      }],
      staticClass: "form_control",
      attrs: {
        "type": "radio",
        "id": "C",
        "value": "C"
      },
      domProps: {
        "checked": _vm._q(_vm.commission_type, "C")
      },
      on: {
        "__c": function($event) {
          _vm.commission_type = "C"
        }
      }
    }), _vm._v("Cash\r\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('b', [_vm._v("Commision:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_group_merchant.commission),
        expression: "paga_service_group_merchant.commission"
      }],
      staticClass: "form_control",
      staticStyle: {
        "width": "30%"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.paga_service_group_merchant.commission)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.paga_service_group_merchant.commission = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_reward_type),
        expression: "paga_service_reward_type"
      }],
      staticClass: "form_control",
      attrs: {
        "type": "radio",
        "id": "P",
        "value": "P"
      },
      domProps: {
        "checked": _vm._q(_vm.paga_service_reward_type, "P")
      },
      on: {
        "__c": function($event) {
          _vm.paga_service_reward_type = "P"
        }
      }
    }), _vm._v("Percentage | \r\n                                                    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_reward_type),
        expression: "paga_service_reward_type"
      }],
      staticClass: "form_control",
      attrs: {
        "type": "radio",
        "id": "C",
        "value": "C"
      },
      domProps: {
        "checked": _vm._q(_vm.paga_service_reward_type, "C")
      },
      on: {
        "__c": function($event) {
          _vm.paga_service_reward_type = "C"
        }
      }
    }), _vm._v("Cash\r\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('b', [_vm._v("Reward:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_group_merchant.reward),
        expression: "paga_service_group_merchant.reward"
      }],
      staticClass: "form_control",
      staticStyle: {
        "width": "30%"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.paga_service_group_merchant.reward)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.paga_service_group_merchant.reward = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_reward_activation_status),
        expression: "paga_service_reward_activation_status"
      }],
      staticClass: "form_control",
      attrs: {
        "type": "radio",
        "id": "1",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(_vm.paga_service_reward_activation_status, "1")
      },
      on: {
        "__c": function($event) {
          _vm.paga_service_reward_activation_status = "1"
        }
      }
    }), _vm._v("Active | \r\n                                                    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_reward_activation_status),
        expression: "paga_service_reward_activation_status"
      }],
      staticClass: "form_control",
      attrs: {
        "type": "radio",
        "id": "0",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(_vm.paga_service_reward_activation_status, "0")
      },
      on: {
        "__c": function($event) {
          _vm.paga_service_reward_activation_status = "0"
        }
      }
    }), _vm._v("Not-Active\r\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('b', [_vm._v("Maximum Purchase Amount:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_group_merchant.max_purchase_amount),
        expression: "paga_service_group_merchant.max_purchase_amount"
      }],
      staticClass: "form_control",
      staticStyle: {
        "width": "30%"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.paga_service_group_merchant.max_purchase_amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.paga_service_group_merchant.max_purchase_amount = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.addPagaServiceGroupMerchants
      }
    }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-action', '')
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : _vm._e(), _vm._v(" "), _c('table', [_vm._m(12, true), _vm._v(" "), _vm._l((service_group.paga_service_group_merchants), function(m) {
      return _c('tr', [(m.paga_service_group_merchant_service_group_type == 'MERCHANT') ? _c('td', {
        staticStyle: {
          "width": "60%",
          "padding": "3px"
        }
      }, [_vm._v("\r\n                                                    " + _vm._s(m.paga_service_group_merchant_displayName) + "\r\n                                                ")]) : _vm._e(), _vm._v(" "), (m.paga_service_group_merchant_service_group_type == 'MOBILEOPS') ? _c('td', {
        staticStyle: {
          "width": "60%",
          "padding": "3px"
        }
      }, [_vm._v("\r\n                                                    " + _vm._s(m.paga_service_group_mobile_operatorName) + "\r\n                                                ")]) : _vm._e(), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%",
          "padding": "3px"
        }
      }, [(m.paga_service_group_merchant_attached_image != '') ? _c('span', [_c('img', {
        staticClass: "img-responsive",
        staticStyle: {
          "height": "3.5em"
        },
        attrs: {
          "src": _vm.img_url + m.paga_service_group_merchant_attached_image
        }
      })]) : _c('span', [_c('input', {
        attrs: {
          "type": "file",
          "id": "input-file",
          "accept": "image/*"
        },
        on: {
          "change": function($event) {
            _vm.onFileChange($event, m.paga_service_group_merchant_id)
          }
        }
      })])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%",
          "padding": "3px"
        }
      }, [_vm._v(_vm._s(m.paga_service_group_merchant_max_purchase_amount))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%",
          "padding": "3px"
        }
      }, [(m.paga_service_group_merchant_commission_type == 'C') ? _c('span', [_vm._v("₦")]) : _vm._e(), _vm._v(_vm._s(m.paga_service_group_merchant_commission)), (m.paga_service_group_merchant_commission_type == 'P') ? _c('span', [_vm._v("%")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%",
          "padding": "3px"
        }
      }, [(m.paga_service_group_merchant_reward_type == 'C') ? _c('span', [_vm._v("₦")]) : _vm._e(), _vm._v(_vm._s(m.paga_service_group_merchant_reward)), (m.paga_service_group_merchant_reward_type == 'P') ? _c('span', [_vm._v("%")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%",
          "padding": "3px",
          "font-size": "12px"
        }
      }, [(m.paga_service_group_merchant_reward_activation_status == 1) ? _c('span', [_vm._v("Active")]) : _c('span', [_vm._v("Not-Active")])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "10%",
          "padding": "3px"
        }
      }, [_c('button', {
        staticClass: "btn btn-primary btn-xs",
        attrs: {
          "type": "button",
          "title": "Edit"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('edit-paga-service-group-merchant', m);
            _vm.setComponentView('edit-paga-service-group-merchant')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      })])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "10%",
          "padding": "3px"
        }
      }, [(_vm.deletePagaServiceGroupMerchant && (_vm.paga_service_group_merchant.paga_service_group_merchant_id == m.paga_service_group_merchant_id)) ? _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Do you really want to delete?\r\n                                                        "), _c('button', {
        staticClass: "btn btn-danger btn-xs",
        attrs: {
          "type": "button",
          "title": "Delete?"
        },
        on: {
          "click": function($event) {
            _vm.deletePagaServiceGroupMerchants()
          }
        }
      }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-default btn-xs",
        attrs: {
          "type": "button",
          "title": "Delete?"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-action', '')
          }
        }
      }, [_vm._v("No")])]) : _c('button', {
        staticClass: "btn btn-danger btn-xs",
        attrs: {
          "type": "button",
          "title": "Delete?"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('delete-paga-service-group-merchant', m)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    })], 2), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-success pull-right",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('add-paga-service-group-merchant', service_group);
          _vm.setComponentView('addPagaServiceGroupMerchant');
        }
      }
    }, [_vm._v("Add New PAGA Service Group Member")]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('br')])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), (!_vm.has_paga_service_group_for_mobile_operator) ? _c('div', {
    staticClass: "pull-left"
  }, [_vm._m(13), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Group Name:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group.group_name),
      expression: "paga_service_group.group_name"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.paga_service_group.group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group.group_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Title:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group.group_title),
      expression: "paga_service_group.group_title"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pay your Electricty Bills...."
    },
    domProps: {
      "value": (_vm.paga_service_group.group_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group.group_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addPagaServiceGroupMobileOperator
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-paga-service-group', '')
      }
    }
  }, [_vm._v("Add New PAGA Service Group")]), _vm._v(" "), _c('br'), _c('br')])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(14), _vm._v(" "), _c('div', [_c('p', [_vm._v("Available Balance at PAGA")]), _vm._v(" "), _c('label', [_vm._v("₦" + _vm._s(_vm.paga_available_balance))])])])])]), _vm._v(" "), _c('component-footer'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "24em"
    },
    attrs: {
      "id": "delete",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#topup')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\r\n                    delete\r\n                ")])])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Change Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Change Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Manage Categories")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Users Plans and Pricing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("CNpro Service Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Processing Fees /  Charges")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("To")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("CNpay Commissions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Default Charges")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Rewards For Services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('u', [_vm._v("Rewards")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("PAGA Services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Merchant")]), _vm._v(" "), _c('th', [_vm._v("Image")]), _vm._v(" "), _c('th', [_vm._v("max")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%",
      "padding": "3px"
    }
  }, [_vm._v("commission")]), _vm._v(" "), _c('th', [_vm._v("reward")]), _vm._v(" "), _c('th', [_vm._v("--~")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Add the Service Group for Mobile Operators")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("PAGA Balance")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e2e059b"}!./src/components/Settings/template.html
// module id = 160
// module chunks = 0